/* global SideDrawer */

if (!customElements.get('facet-filters')) {
  class FacetFilters extends SideDrawer {
 

    

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'open') {
        if (this.hasAttribute('open')) {
          this.style.removeProperty('display');
          this._toggleWrapper(true); // Toon de buitenste container
        } else {
          if (!(window.theme && theme.mediaMatches && theme.mediaMatches.lg)) {
            this.style.setProperty('display', 'none', 'important');
            this._toggleWrapper(false); // Verberg de buitenste container
          }
        }
      }
      if (super.attributeChangedCallback) {
        super.attributeChangedCallback(name, oldValue, newValue);
      }
    }

    open() {
      this.style.removeProperty('display');
      this._toggleWrapper(true); // Toon de buitenste container
      if (super.open) super.open();
    }
close() {
      if (super.close) {
        super.close();
      } else {
        this.removeAttribute('open');
      }
      this.style.setProperty('display', 'none', 'important');
      this._toggleWrapper(false); // Verberg de witte container op ALLE schermen
      document.documentElement.classList.remove('side-drawer-open', 'modal-open', 'overflow-hidden');
      document.body.classList.remove('side-drawer-open', 'modal-open', 'overflow-hidden');
    }

    _toggleWrapper(show) {
  const wrapper = this.closest('.main-products-grid__filters');
  if (!wrapper) return;

  if (show) {
    wrapper.style.removeProperty('display');
  } else {
    wrapper.style.setProperty('display', 'none', 'important');
  }
}

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {
      window.removeEventListener('popstate', this.historyChangeHandler);
      if (this.breakpointChangeHandler) {
        window.removeEventListener('on:breakpoint-change', this.breakpointChangeHandler);
      }
    }

    init() {
      this.filteringEnabled = this.dataset.filtering === 'true';
      this.sortingEnabled = this.dataset.sorting === 'true';
      this.form = document.getElementById('facets');
      this.results = document.getElementById('filter-results');
      this.expanded = [];
      this.filterChangeTimeout = null;

      if (!this.hasAttribute('open') && !(window.theme && theme.mediaMatches && theme.mediaMatches.lg)) {
        this.style.setProperty('display', 'none', 'important');
        this._toggleWrapper(false); // Standaard verbergen bij laden op mobiel
      }

      this.handleBreakpointChange();
      this.addElements();
      this.addListeners();

      // ======================================================================
      // MASTER EVENT DELEGATION (Immuun voor HTML updates van de server)
      // ======================================================================
      this.addEventListener('click', (evt) => {
        // Zoek of de klik landde op (of binnen) een sluitknop of de groene actieknop
        const closeTarget = evt.target.closest(
          '.glass-drawer__close-btn, .glass-action-btn, .js-close-drawer-mob, .js-close-drawer'
        );

        if (closeTarget) {
          evt.preventDefault();
          evt.stopPropagation();
          this.close(); // Sluit direct het complete menu zonder filters te lozen
        }
      });
      // Koppel de "Filter" knop in de toolbar aan open/sluiten
      const toggleBtn = document.querySelector('.js-toggle-filters');
      if (toggleBtn) {
        toggleBtn.addEventListener('click', (evt) => {
          evt.preventDefault();
          if (this.hasAttribute('open')) {
            this.close();
            toggleBtn.setAttribute('aria-expanded', 'false');
          } else {
            this.open();
            toggleBtn.setAttribute('aria-expanded', 'true');
          }
        });
      }

      this.historyChangeHandler = this.historyChangeHandler || this.handleHistoryChange.bind(this);
      window.addEventListener('popstate', this.historyChangeHandler);
    }

    addElements() {
      if (this.filteringEnabled) {
        this.filters = this.querySelector('.facets__filters');
        this.activeFilters = this.querySelector('.facets__active-filters');
        this.activeFiltersList = this.querySelector('.active-filters');
        this.activeFiltersHeader = this.querySelector('.active-filters-header');
        this.footer = this.querySelector('.facets__footer');
      }

      if (this.sortingEnabled) {
        this.desktopSortBy = document.getElementById('sort-by') || this.querySelector('[id^="sort-by"]');
      }
    }

    addListeners() {
      if (this.filteringEnabled) {
        this.breakpointChangeHandler = this.breakpointChangeHandler
          || this.handleBreakpointChange.bind(this);
        
        this.filtersClickHandler = this.filtersClickHandler || this.handleFiltersClick.bind(this);
        this.filterChangeHandler = this.filterChangeHandler || this.handleFilterChange.bind(this);
        this.activeFiltersClickHandler = this.activeFiltersClickHandler || this.handleActiveFiltersClick.bind(this);

        if (this.filters) {
          this.filters.removeEventListener('click', this.filtersClickHandler);
          this.filters.addEventListener('click', this.filtersClickHandler);
          this.filters.removeEventListener('input', this.filterChangeHandler);
          this.filters.addEventListener('input', this.filterChangeHandler);
          this.filters.removeEventListener('change', this.filterChangeHandler);
          this.filters.addEventListener('change', this.filterChangeHandler);
        }
        
        if (this.activeFilters) {
          this.activeFilters.removeEventListener('click', this.activeFiltersClickHandler);
          this.activeFilters.addEventListener('click', this.activeFiltersClickHandler);
        }

        window.removeEventListener('on:breakpoint-change', this.breakpointChangeHandler);
        window.addEventListener('on:breakpoint-change', this.breakpointChangeHandler);
      }

      if (this.sortingEnabled && this.desktopSortBy) {
        this.filterChangeHandler = this.filterChangeHandler || this.handleFilterChange.bind(this);
        this.desktopSortBy.removeEventListener('change', this.filterChangeHandler);
        this.desktopSortBy.addEventListener('change', this.filterChangeHandler);
      }
    }

    handleBreakpointChange() {
      if (window.theme && theme.mediaMatches && theme.mediaMatches.lg) {
        this.setAttribute('aria-hidden', 'false');
        this.removeAttribute('aria-modal');
        this.removeAttribute('role');
      } else {
        if (!this.hasAttribute('open')) {
          this.close();
        }
        this.setAttribute('role', 'dialog');
        this.setAttribute('aria-modal', 'true');
      }
    }

    handleFilterChange(evt) {
      if (evt.type === 'change' && !(evt.target.id?.includes('price-range') || evt.target.id?.includes('sort-by'))) return;
      if (evt.target.id?.includes('price-range') && evt.constructor.name === 'InputEvent') return;

      const timeoutDelay = 500;
      clearTimeout(this.filterChangeTimeout);

      this.filterChangeTimeout = setTimeout(() => {
        const formData = new FormData(this.form);
        const searchParams = new URLSearchParams(formData);
        const emptyParams = [];

        if (this.sortingEnabled) {
          let currentSortBy = searchParams.get('sort_by');

          if (evt.target.tagName === 'CUSTOM-SELECT') {
            this.mobileSortByOptions = this.mobileSortByOptions || this.querySelectorAll('.sort-by__option');
            this.mobileSortByOptions.forEach((option) => {
              option.checked = option.value === evt.detail.selectedValue;
              currentSortBy = evt.detail.selectedValue;
            });
          }
          searchParams.set('sort_by', currentSortBy);
        }

        searchParams.forEach((value, key) => {
          if (!value) emptyParams.push(key);
        });

        emptyParams.forEach((key) => {
          searchParams.delete(key);
        });

        this.applyFilters(searchParams.toString(), evt);
      }, timeoutDelay);
    }

    handleFiltersClick(evt) {
      const { target } = evt;

      if (target.matches('.js-clear-filter')) {
        evt.preventDefault();
        this.applyFilters(new URL(evt.target.href).searchParams.toString(), evt);
      }

      if (target.matches('.js-show-more')) {
        const filter = target.closest('.filter');
        target.remove();

        filter.querySelectorAll('li').forEach((el) => {
          el.classList.remove('js-hidden');
        });

        if (!this.expanded.includes(filter.id)) {
          this.expanded.push(filter.id);
        }
      }
    }

    handleActiveFiltersClick(evt) {
      if (evt.target.tagName !== 'A') return;
      evt.preventDefault();
      this.applyFilters(new URL(evt.target.href).searchParams.toString(), evt);
    }

    handleHistoryChange(evt) {
      if (evt.state !== null) {
        let searchParams = '';
        if (evt.state && evt.state.searchParams) {
          ({ searchParams } = evt.state);
        }
        this.applyFilters(searchParams, null, false);
      }
    }

    async applyFilters(searchParams, evt, updateUrl = true) {
      try {
        const activeElementId = document.activeElement ? document.activeElement.id : null;
        const customPagination = document.querySelector('custom-pagination');
        if (customPagination) customPagination.dataset.pauseInfiniteScroll = 'true';

        if (this.results) this.results.classList.add('is-loading');

        let fetchUrl = `${window.location.pathname}?${searchParams}`;
        if (this.form && this.form.dataset.filterSectionId) {
          fetchUrl += `&section_id=${this.form.dataset.filterSectionId}`;
        }

        if (this.applyFiltersFetchAbortController) {
          this.applyFiltersFetchAbortController.abort('Request changed');
        }
        this.applyFiltersFetchAbortController = new AbortController();

        const response = await fetch(fetchUrl, {
          method: 'GET',
          signal: this.applyFiltersFetchAbortController.signal
        });

        if (response.ok) {
          const text = await response.text();
          const tmpl = document.createElement('template');
          tmpl.innerHTML = text;

          if (this.form) {
            this.form.querySelectorAll('details-disclosure > details').forEach((existingFilter) => {
              const target = tmpl.content.getElementById(existingFilter.id);
              if (target) {
                target.open = existingFilter.open;
              }
            });

            tmpl.content.querySelectorAll('#facets details-disclosure > details').forEach((newFilter) => {
              if (this.expanded.includes(newFilter.id)) {
                const hiddenElements = newFilter.querySelectorAll('.js-hidden');
                hiddenElements.forEach((listItem) => {
                  listItem.classList.remove('js-hidden');
                });
                newFilter.querySelector('.filter__more')?.remove();
              }
            });

            const newFacets = tmpl.content.getElementById('facets');
            if (newFacets) this.form.innerHTML = newFacets.innerHTML;
          }

          if (this.results) {
            const currentResultsUl = this.results.querySelector('ul');
            if (currentResultsUl) {
              this.currentResultsClass = currentResultsUl.getAttribute('class');
            }

            const newResultsHTML = tmpl.content.getElementById('filter-results');
            if (newResultsHTML) {
              this.results.innerHTML = newResultsHTML.innerHTML;
            }

            const newResultsUl = this.results.querySelector('ul');
            if (newResultsUl && this.currentResultsClass) {
              newResultsUl.setAttribute('class', this.currentResultsClass);
            }
          }

          const newFooter = tmpl.content.querySelector('.glass-drawer__footer');
          const currentFooter = this.querySelector('.glass-drawer__footer');
          if (newFooter && currentFooter) {
            currentFooter.innerHTML = newFooter.innerHTML;
          }

          this.addElements();
          this.addListeners();

          if (customPagination && customPagination.reload) customPagination.reload();
          if (updateUrl) FacetFilters.updateURL(searchParams);
          if (activeElementId) document.getElementById(activeElementId)?.focus();

          document.dispatchEvent(new CustomEvent('on:facet-filters:updated'), { bubbles: true });
        }
      } catch (error) {
        console.warn(error);
      } finally {
        if (this.results) this.results.classList.remove('is-loading');
        const customPagination = document.querySelector('custom-pagination');
        if (customPagination) customPagination.dataset.pauseInfiniteScroll = 'false';
      }
    }

    static updateURL(searchParams) {
      window.history.pushState(
        { searchParams },
        '',
        `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`
      );
    }
  }

  customElements.define('facet-filters', FacetFilters);

  


  
}


  